import React from "react";
import { Row, Col, Descriptions, Card } from "antd";
import { useQuery } from "@apollo/react-hooks";
import { GetOrg } from "../../graphql/organization";
import { useParams } from "react-router-dom";
import { FundraiserCard } from "../../components/fundraiser/FundraiserCard";
import { fmtDateTime } from "../../common/Utils";
import { Store } from "../../store/Store";

export const OrgDashboard = () => {
  let { id } = useParams<any>();
  const { loading, data: { org } = { org: { id } }, refetch } = useQuery<any>(GetOrg, { variables: { id } });
  // const [showSubDlg, setShowSubDlg] = useState(false);
  // const [showAdminDlg, setShowAdminDlg] = useState(false);
  // const [showEditDlg, setShowEditDlg] = useState(false);
  // const [model, setModel] = useState({ id: null });
  // const [tab, setTab] = useState("main");

  // const fo = org?.children?.find((x) => x.id === tab);

  // const editSub = (m) => {
  //   setModel(m);
  //   setShowSubDlg(true);
  // };

  // const onEditClose = () => {
  //   setShowEditDlg(false);
  //   refetch();
  // };

  // const onSubClose = () => {
  //   setShowSubDlg(false);
  //   refetch();
  // };
  // const onAdminClose = () => {
  //   setShowAdminDlg(false);
  //   refetch();
  // };

  // const onTab = (key) => {
  //   if (key !== "add") setTab(key);
  // };

  // const addAdmin = () => setShowAdminDlg(true);

  return (
    <>
      <Card>
        <Descriptions size="small" column={3}>
          <Descriptions.Item label="Creation Time">{fmtDateTime(org?.createDate)}</Descriptions.Item>
          <Descriptions.Item label="Address" span={1}>
            {org?.street}, {org?.city}, {org?.state} {org?.zipCode}
          </Descriptions.Item>
          <Descriptions.Item label="Notes" span={1}>
            {org?.description}
          </Descriptions.Item>
          <Descriptions.Item label="Grade List" span={2}>
            {org?.grades?.join(", ")}
          </Descriptions.Item>
        </Descriptions>
      </Card>
      <Row gutter={20} style={{ marginTop: 15 }}>
        <Col span={24}>{Store.isDivision ? null : <FundraiserCard />}</Col>
        {/* <Col span={6}>
          <OrgAdminCard orgId={id} style={{}} />
        </Col> */}
      </Row>
    </>
  );
};
